import { ResourceWithDurationAndType } from '@pages/CatalogPage/utils/taxonomy';
import { AtlenzCatalogResource, AtlenzContentType } from 'src/services/http/search';
import { ContentType } from 'src/types';
import { ResourceType } from 'src/constants';
import { COLLECTION_TYPES } from 'src/pages/CatalogPage/children/CardsList';

export const getResourceProduct = (resource: ResourceWithDurationAndType | AtlenzCatalogResource): string[] => {
  if ('relatedCertification' in resource && resource.__typename === ContentType.CERTIFICATION_PREP) {
    return resource.relatedCertification?.product || [];
  }

  return 'product' in resource ? resource.product : [];
};

export const getResourceContentType = (
  resource: ResourceWithDurationAndType | AtlenzCatalogResource,
): AtlenzContentType | ResourceType => {
  if ('__typename' in resource) {
    return COLLECTION_TYPES.includes(resource.__typename as ContentType)
      ? ResourceType.Collection
      : ResourceType[resource.__typename as keyof typeof ResourceType];
  }

  return resource.type;
};
